"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../material/index");

var _searchresultnav = _interopRequireDefault(require("./searchresultnav/searchresultnav"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _search_styles = _interopRequireDefault(require("./search_styles"));

var _search_definition = _interopRequireDefault(require("./search_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*README: To implement this search component with search props (components that appear on left and right of search bar), refer to the following
implementation which renders a search-based dropfilter on the left side of the searchbar, as well as a searchresultnav on the right side of the searchbar:

   <Search  dropfilter={{alignment: 'left', onSelect: (args)=>console.log(args),
                         items: [{value: 'lol', name: 'lol'}, {value: 'lol1', name: 'lol1'}],
                         selectedItems: ['lol1'], title: 'Questions'}}
            searchresultnav={{alignment: 'right', visible: true, clearResults: ()=>console.log('here'),
                              handleResultsNav: (args)=>console.log(args), currentResult: 16, resultsCount: 18}}
            onChange={(result)=>console.log(result)}
            placeholder={'Search'}/>

Note how each prop corresponds to a unique component and contains the required properties for that component such as callbacks etc.
More components can be added in this way; a prop corresponding to the new component should simply be passed from the parent component calling the Search component.
The alignment property is MANDATORY for the component to render when represented as a prop.

The parent component must handle responsiveness for the Search component based on which components are implemented as props.
Other props for the search-bar functionality include:
onFocus, onBlur, onChange, placeholder, value (some included in example above)
*/

/* ========== ~~~~~~~~~~ EXPORT : SEARCH ~~~~~~~~~~ ========== */


var Search = (0, _reactJss.default)(_search_styles.default)(function (props) {
  //getAlignedSearchPropNames returns an array of all the prop names that correspond to a particular alignment (left/right).
  var getAlignedSearchPropNames = function getAlignedSearchPropNames(alignment) {
    return Object.keys(props).filter(function (propName) {
      return props[propName]['alignment'] === alignment;
    });
  }; //removeSearchPropsFromProperties removes search properties from the properties objects that represent components.


  var removeSearchPropsFromProperties = function removeSearchPropsFromProperties(properties) {
    delete properties.alignment;
    return properties;
  }; //getElementFromProperties returns the element corresponding to the given type argument. The element is infused with the given
  //  properties, and other baseline properties.


  var getElementFromProperties = function getElementFromProperties(type, properties) {
    switch (type) {
      case 'dropfilter':
        return _react.default.createElement(_index.MultiSelectDropDown, _extends({
          icon: 'sort-down',
          button: "false"
        }, removeSearchPropsFromProperties(properties), {
          transparent: true
        }));

      case 'searchresultnav':
        return _react.default.createElement(_searchresultnav.default, removeSearchPropsFromProperties(properties));

      default:
        return null;
    }
  }; //renderAlignedSearchProps generates the search elements based on the given alignment. Each search element is enclosed in a div with a
  //  dynamically generated classname.


  var renderAlignedSearchProps = function renderAlignedSearchProps(alignment) {
    return getAlignedSearchPropNames(alignment).map(function (propName) {
      return _react.default.createElement("div", {
        className: "".concat(alignment, "-child ").concat(propName)
      }, getElementFromProperties(propName, props[propName]));
    });
  };

  return _react.default.createElement("div", {
    className: "search ".concat(props.classes.search)
  }, _react.default.createElement("div", {
    className: 'left-parent'
  }, renderAlignedSearchProps('left')), _react.default.createElement(_index.Icon, {
    klass: 'search-icon',
    name: "search"
  }), _react.default.createElement("span", {
    className: "element"
  }, _react.default.createElement("input", {
    placeholder: props.placeholder,
    onFocus: props.handleFocus,
    onBlur: props.handleBlur,
    onChange: function onChange(e) {
      return props.onChange(e.target.value);
    },
    value: props.value
  })), _react.default.createElement("div", {
    className: 'right-parent'
  }, renderAlignedSearchProps('right')));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Search, _search_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Search;
exports.default = _default;